import React, { useState } from 'react';
import ReactStrapTable from 'components/reactStrapTable';
import { dateFormate, cellRendererCheck } from 'utils/columns';
import EyeIcon from 'assets/icon/icon-icon-options-view-patient.svg';
import EyeIconHover from 'assets/icon/icon-icon-options-view-patient_hover.svg';
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import EditIconHover from 'assets/icon/icon-icon-options-edit_hover.svg';
import HoverImage from 'react-hover-image/build';
import { Button } from 'reactstrap';
import UserAddEditModal from '../UserAddEditModal';

const col = [
  'Status',
  'User Name',
  'First Name',
  'Last Name',
  'Entity Name',
  'Role',
  'Access Level',
  'Email ID',
  'Last Login Date',
  'Options',
];


const UsersTable = ({ loading, data }) => {
  const [state, updateState] = useState({
    modalKey: '',
    isModalOpen: false,
    rowData: null
  });

  const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));

  const { modalKey, isModalOpen, rowData } = state;

  const toggleUserModal = (modalKey='', hasData, rowData) => {
    setState({
      isModalOpen: !isModalOpen,
      modalKey: modalKey
    });
    if(hasData){
      setState({
        rowData: rowData,
      });
    }
  };

  
const columns = [
  {
    dataField: 'status',
    text: 'Status',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    cellRenderer: (rowData) => cellRendererCheck(rowData.status),
  },
  {
    dataField: 'userName',
    text: 'User Name',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    cellRenderer: (rowData) => cellRendererCheck(rowData.userName),
  },
  {
    dataField: 'firstName',
    text: 'First Name',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    cellRenderer: (rowData) => cellRendererCheck(rowData.firstName),
  },
  {
    dataField: 'lastName',
    text: 'Last Name',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    cellRenderer: (rowData) => cellRendererCheck(rowData.lastName),
  },
  {
    dataField: 'entityName',
    text: 'Entity Name',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    cellRenderer: (rowData) => cellRendererCheck(rowData.entityName),
  },
  {
    dataField: 'role',
    text: 'Role',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    cellRenderer: (rowData) => cellRendererCheck(rowData.role),
  },
  {
    dataField: 'accessLevel',
    text: 'Access Level',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    cellRenderer: (rowData) => cellRendererCheck(rowData.accessLevel),
  },
  {
    dataField: 'emailID',
    text: 'Email ID',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    cellRenderer: (rowData) => cellRendererCheck(rowData.emailID),
  },
  {
    dataField: 'lastLoginDate',
    text: 'Last Login Date',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    cellRenderer: (rowData) => dateFormate(rowData.lastLoginDate),
  },
  {
    dataField: 'options',
    text: 'Options',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    cellRenderer: (rowData) => onEditRender(rowData),
  },
];

const onEditRender = (rowData) => {
  return (
    <div>
      <Button className="text-primary p-0 text-decoration-none" color="link" onClick={() => toggleUserModal('UPDATE',true,rowData)} >
        <HoverImage src={EyeIcon} hoverSrc={EyeIconHover} />
      </Button>
      <Button className="text-primary p-0 text-decoration-none" color="link">
        <HoverImage src={EditIcon} hoverSrc={EditIconHover} />
      </Button>
    </div>
  );
};

  return (
    <div
      className="table-card scroll-table position-relative border-0 rounded pt-0"
      fixed-height={data.length > 0 ? 'fixed-height' : 'default'}
    >
      <ReactStrapTable
        id="users-table"
        hasPagination
        pageSize={10}
        totalRecords={data.length}
        currentPage={1}
        onExport={() => ''}
        columns={columns}
        data={data}
        loading={loading}
      >
         <Button color="primary" size="sm" onClick={() => toggleUserModal("ADD")} >
         USER REGISTRATION
        </Button>
        <div className="mx-4 text-light f-0 text-white font-weight-lighter border-end">
          |
        </div>
      </ReactStrapTable>
      <UserAddEditModal rowData={rowData} modalKey={modalKey} toggle={toggleUserModal} isModalOpen={isModalOpen} />
    </div>
  );
};

export default UsersTable;
